import {
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
} from '@tabler/icons-react';
import { Button } from 'design-system/button/button';
import { Kbd, KbdGroup } from 'design-system/kbd/kbd';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'design-system/tooltip/tooltip';

const MOD_KEY =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad|iPod/.test(navigator.userAgent)
    ? '⌘'
    : 'Ctrl';

interface SidebarToggleProps {
  collapsed?: boolean;
  onToggle?: () => void;
}

export const SidebarToggle = ({
  collapsed = false,
  onToggle,
}: SidebarToggleProps) => {
  const label = collapsed ? 'Expand sidebar' : 'Collapse sidebar';

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant="ghost"
            size="icon"
            onClick={onToggle}
            aria-label={label}
          >
            {collapsed ? (
              <IconLayoutSidebarLeftExpand />
            ) : (
              <IconLayoutSidebarLeftCollapse />
            )}
          </Button>
        }
      />
      <TooltipContent side="right" className="flex items-center gap-2">
        {label}
        <KbdGroup>
          <Kbd>{MOD_KEY}</Kbd>
          <Kbd>.</Kbd>
        </KbdGroup>
      </TooltipContent>
    </Tooltip>
  );
};
SidebarToggle.displayName = 'SidebarToggle';
